export default __webpack_public_path__ + "static/media/189.f6c2d34c.jpg";